import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { AnalyticsProvider } from './shared/Analytics';
import paths from './utils/paths';
import Scaffold from './containers/Scaffold';
import Theme from './components/Theme';
import ConfigContextProvider from './containers/ConfigContextProvider';
import { ENABLE_NEW_CONFIGURATOR } from './settings';
import V3Configurator from './v3/Main';

const Wrapper = styled.div`
  height: inherit;
`;

class App extends Component {
  componentDidMount() {
    // Remove the Loader
    if (typeof document !== 'undefined') {
      const loader = document.getElementById('loader'); // eslint-disable-line no-undef
      if (loader) {
        loader.classList.add('hideLoader');
        setTimeout(() => {
          loader.parentNode.removeChild(loader);
        }, 500);
      }
    }
    this.mainDiv.style.display = 'block';
  }

  render() {
    const {
      location: {
        pathname
      }
    } = this.props;

    // Use the new scaffold layout when using the new configurator path
    const isNewConfigurtorUrl = pathname.includes(paths.FF91_DESIGN_PREFIX);

    return (
      <Theme>
        <Wrapper
          ref={(element) => {
            this.mainDiv = element;
          }}
        >
          <Route path="/:region/:entry" />
          <AnalyticsProvider>
            <ConfigContextProvider>
              {(ENABLE_NEW_CONFIGURATOR && isNewConfigurtorUrl) ? (
                <V3Configurator />
              ) : (
                <Scaffold />
              )}
            </ConfigContextProvider>
          </AnalyticsProvider>
        </Wrapper>
      </Theme>
    );
  }
}

export default withRouter(App);

